module.exports = __webpack_public_path__ + "img/product5.752d3bb4.png";